module.exports = __webpack_public_path__ + "916edbbe8c4d92af6b2400ce7dab50de.svg";